var _circle, _circle2, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStakeMiningLight = function SvgStakeMiningLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 27.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 27.857,
    stroke: "#313154",
    strokeOpacity: 0.1,
    strokeWidth: 0.714
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stake-mining-light_svg__a)",
    fillRule: "evenodd",
    d: "M16.19 14.667h25.398c2.191 0 3.968 1.705 3.968 3.81v3.14a7.77 7.77 0 0 0-3.333 6.384 7.77 7.77 0 0 0 3.333 6.383v3.14c0 2.104-1.777 3.81-3.968 3.81H16.19c-2.192 0-3.968-1.706-3.968-3.81V18.476c0-2.104 1.776-3.81 3.968-3.81",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stake-mining-light_svg__b)",
    d: "M41.852 14.667H15.926c-2.045 0-3.703 1.705-3.703 3.81v19.047c0 2.104 1.658 3.81 3.703 3.81h25.926c2.046 0 3.704-1.706 3.704-3.81V18.476c0-2.104-1.658-3.81-3.704-3.81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#stake-mining-light_svg__c)",
    d: "M32.222 33.555a5.556 5.556 0 1 0 0-11.11 5.556 5.556 0 0 0 0 11.11"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#stake-mining-light_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#stake-mining-light_svg__e)",
    d: "M24.444 33.555a5.556 5.556 0 1 0 0-11.11 5.556 5.556 0 0 0 0 11.11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "stake-mining-light_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(79.38 1.25 31.746)scale(9.04379)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252551"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "stake-mining-light_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(78.69 -3.439 27.18)scale(8.49837)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E54A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343479"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-mining-light_svg__a",
    x1: 45.556,
    x2: -11.955,
    y1: 41.333,
    y2: 19.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#859CDA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stake-mining-light_svg__b",
    x1: 47.778,
    x2: -12.691,
    y1: 41.333,
    y2: 16.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#859CDA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stake-mining-light_svg__d",
    width: 15.556,
    height: 15.556,
    x: 16.666,
    y: 20.222,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.111
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_404_3303"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_404_3303",
    result: "shape"
  })))));
};
export { SvgStakeMiningLight as ReactComponent };
export default "data:image/svg+xml;base64,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";